import React from "react";

import { Grid, Bar } from "./Styles";

const QuestionDetailRating = ({ question, surveys }) => {
    const [data, setData] = React.useState([]);
    const [count, setCount] = React.useState(0);

    React.useEffect(() => {
        const counter = {};
        let _count = 0;
        surveys.forEach((survey) => {

            if (survey[question.value]) {
                _count++;
                if (counter[`c${survey[question.value]}`] === undefined) {
                    counter[`c${survey[question.value]}`] = 0;
                }

                counter[`c${survey[question.value]}`]++;
            }
        });

        const _data = [];

        for (let index in counter) {
            _data.push({ count: counter[index], label: index.replace("c", "") })
        }

        setData(_data);
        setCount(_count);

        _data.sort((a, b) => {
            a.label = parseInt(a.label);
            b.label = parseInt(b.label);
            if (a.label > b.label) {
                return -1;
            }
            if (a.label < b.label) {
                return 1;
            }

            return 0;
        })
    }, [question, surveys]);

    return (
        <React.Fragment>
            <div className="pos-relative">
                <Grid>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value, index) => {
                        return <span key={value}></span>
                    })}
                </Grid>
                {data.map((ans, index) => {

                    const percent = ans.count * 100 / count;
                    return (
                        <Bar key={index}>
                            <label
                                style={{ width: `${percent}%` }}
                                title={`${percent.toFixed(0)}%, ${ans.count} Respuestas`}>
                                {ans.label} ({percent.toFixed(0)}%)
                            </label>

                        </Bar>
                    )
                })}

            </div>
        </React.Fragment>
    )
}

export default QuestionDetailRating;